import React from 'react'

const SvgUserOutline = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width='1em' height='1em' viewBox='0 0 24 24' {...props}>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M17 7A5 5 0 117 7a5 5 0 0110 0zm-2 0a3 3 0 10-6 0 3 3 0 006 0zM2 20c0-4 2.001-6 6.004-6H16c4 0 6 2 6 6 0 1.333-.667 2-2 2H4c-1.333 0-2-.667-2-2zm6-4c-2.667 0-4 1.333-4 4h16c0-2.667-1.333-4-4-4H8z'
    />
  </svg>
)

export default SvgUserOutline
